'use client';

import type { ImageType } from '@eliadmin/core/src/api/api-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Link from '@eliadmin/core/src/components/link';
import { SubpageHeader } from '@eliadmin/core/src/components/ui/subpage-header';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { GoArrowUpRight } from 'react-icons/go';

export type Category = {
  data?: Category[];
  childs: Category[];
  name: string;
  description: string;
  short_description: string;
  slug: string;
  icon?: string;
  image?: ImageType;
};

type CategoriesPageNewProps = {
  categories: Category[];
};

export const CategoriesPageNew = ({ categories }: CategoriesPageNewProps) => {
  const { t } = useTranslations();

  return (
    <>
      <SubpageHeader name={t('text176')} slug="kategorie" />
      <section className={cn('custom-section', 'py-10 sm:py-12 md:py-14')}>
        <div
          className={cn(
            'custom-container',
            'grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 md:gap-6 lg:grid-cols-4',
          )}
        >
          {categories.map(category => (
            <SubcategoryCard subcategory={category} key={category.slug} />
          ))}
        </div>
      </section>
    </>
  );
};

function SubcategoryCard({ subcategory }: { subcategory: Category }) {
  return (
    <Link
      href={subcategory?.slug ?? ''}
      className={cn(
        'ea-rounded-xl flex items-start justify-between gap-3 bg-white p-3 md:p-6',
        'ea-subcategory-card',
      )}
    >
      <Heading title={subcategory.name} tag="h2" visualTag="h5" />
      <GoArrowUpRight className="max-h-5 min-h-5 min-w-5 max-w-5 text-border md:max-h-6 md:min-h-6 md:min-w-6 md:max-w-6" />
    </Link>
  );
}
